(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-product"] && !Shopify.designMode) return;
  try {
    
  class MpBuyBox extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-form]');
      if (!this.form) return;
      this.variantInput = this.querySelector('[data-variant-input]');
      this.planInput = this.querySelector('[data-plan-input]');
      this.subInput = this.querySelector('[data-sub-input]');
      this.subToggle = this.querySelector('[data-sub-toggle]');
      this.tiers = Array.from(this.querySelectorAll('[data-tier]'));
      this.submitButtons = Array.from(this.querySelectorAll('[data-submit], [data-sticky-submit]'));

      this.tiers.forEach((input) => input.addEventListener('change', () => this.update()));
      if (this.subInput) this.subInput.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
      const once = this.querySelector('[data-buy-once]');
      if (once) {
        once.addEventListener('click', () => {
          this.buyOnce = true;
          this.form.requestSubmit();
        });
      }

      this.update();
      this.initGallery();
      this.initSticky();
      this.initShipDate();
      this.initCountdown();
    }

    get selected() {
      return this.tiers.find((input) => input.checked) || this.tiers[0];
    }

    update() {
      const input = this.selected;
      if (!input) return;
      const hasPlan = Boolean(input.dataset.plan);
      const subscribed = Boolean(this.subInput && this.subInput.checked && hasPlan);

      this.tiers.forEach((tier) => {
        const card = tier.closest('.mp-tier');
        card.classList.toggle('is-selected', tier === input);
        const showSub = Boolean(this.subInput && this.subInput.checked && tier.dataset.plan);
        card.querySelectorAll('[data-sub]').forEach((el) => (el.hidden = !showSub));
        card.querySelectorAll('[data-once]').forEach((el) => {
          const twin = el.parentElement.querySelector(':scope > [data-sub]');
          el.hidden = showSub && Boolean(twin);
        });
      });

      this.variantInput.value = input.value;
      if (this.planInput) {
        this.planInput.disabled = !subscribed;
        this.planInput.value = subscribed ? input.dataset.plan : '';
      }
      const subInfo = this.querySelector('[data-sub-info]');
      if (subInfo) {
        subInfo.hidden = !hasPlan;
        const refill = subInfo.querySelector('[data-sub-refill]');
        if (refill && input.dataset.subNote) refill.textContent = input.dataset.subNote;
        const oncePrice = subInfo.querySelector('[data-once-price]');
        if (oncePrice) oncePrice.textContent = input.dataset.price;
      }
      if (this.subToggle) {
        this.subToggle.hidden = !hasPlan;
        const note = this.subToggle.querySelector('[data-sub-note]');
        if (note && input.dataset.subNote && !note.dataset.fixed) {
          if (!note.dataset.base) note.dataset.base = note.textContent.trim();
          note.textContent = input.dataset.subNote + (note.dataset.base ? ' · ' + note.dataset.base : '');
        }
      }

      const price = subscribed ? input.dataset.subPrice : input.dataset.price;
      const priceEl = this.querySelector('[data-submit-price]');
      if (priceEl) priceEl.textContent = '– ' + price;
      const stickyTitle = this.querySelector('[data-sticky-title]');
      const stickyPrice = this.querySelector('[data-sticky-price]');
      if (stickyTitle) stickyTitle.textContent = input.dataset.title;
      if (stickyPrice) stickyPrice.textContent = price + (subscribed ? ' · subscription' : '');
    }

    /* Re-renders the theme cart drawer with the fresh cart and opens it. Returns false when the page has no drawer. */
    async openCartDrawer() {
      try {
        const wrapper = document.getElementById('shopify-section-cart-drawer-section');
        if (!wrapper || !document.getElementById('cart-drawer')) return false;
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const response = await fetch(root + '?sections=cart-drawer-section');
        if (!response.ok) return false;
        const html = (await response.json())['cart-drawer-section'];
        if (!html) return false;
        const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('shopify-section-cart-drawer-section');
        if (!fresh || !fresh.querySelector('#cart-drawer')) return false;
        wrapper.innerHTML = fresh.innerHTML;
        await customElements.whenDefined('theme-drawer');
        const drawer = document.getElementById('cart-drawer');
        if (!drawer || typeof drawer.open !== 'function') return false;
        drawer.open();
        document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach((el) => {
          const badge = fresh.querySelector('.theme-drawer__badge');
          if (badge) el.textContent = badge.textContent.trim();
        });
        return true;
      } catch (err) {
        return false;
      }
    }

    async onSubmit(event) {
      if (!window.fetch) return;
      event.preventDefault();
      const input = this.selected;
      const subscribed = Boolean(this.subInput && this.subInput.checked && input.dataset.plan && !this.buyOnce);
      this.buyOnce = false;
      const main = { id: Number(input.value), quantity: 1 };
      if (subscribed) main.selling_plan = Number(input.dataset.plan);
      const items = [main];
      (input.dataset.gifts || '').split(',').filter(Boolean).forEach((id) => {
        items.push({ id: Number(id), quantity: 1, properties: { _gift: 'true', _parent_variant: String(input.value) } });
      });

      const error = this.querySelector('[data-error]');
      if (error) error.hidden = true;
      this.submitButtons.forEach((button) => (button.disabled = true));
      const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };

      try {
        if (this.dataset.replaceCart === 'true') {
          await fetch('/cart/clear.js', { method: 'POST', headers });
        }
        const response = await fetch('/cart/add.js', { method: 'POST', headers, body: JSON.stringify({ items }) });
        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          throw new Error(data.description || data.message || 'Could not add to cart');
        }
        const after = this.dataset.afterAdd;
        if (after === 'drawer' && (await this.openCartDrawer())) {
          this.submitButtons.forEach((button) => (button.disabled = false));
          return;
        }
        window.location.href = after === 'checkout' ? '/checkout' : this.dataset.cartUrl || '/cart';
      } catch (err) {
        this.submitButtons.forEach((button) => (button.disabled = false));
        if (error) {
          error.textContent = err.message;
          error.hidden = false;
        }
      }
    }

    initGallery() {
      const gallery = this.querySelector('[data-gallery]');
      const thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      if (!gallery || !thumbs.length) return;
      const slides = Array.from(gallery.children);
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const slide = slides[Number(thumb.dataset.thumb)];
          if (slide) gallery.scrollTo({ left: slide.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
        });
      });
      let frame;
      gallery.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const position = gallery.scrollLeft + slides[0].offsetLeft;
          let index = 0;
          slides.forEach((slide, i) => {
            if (Math.abs(slide.offsetLeft - position) < Math.abs(slides[index].offsetLeft - position)) index = i;
          });
          thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
        });
      }, { passive: true });
    }

    initSticky() {
      const sticky = this.querySelector('[data-sticky]');
      const submit = this.querySelector('[data-submit]');
      if (!sticky || !submit || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(([entry]) => {
        sticky.hidden = entry.isIntersecting;
      }).observe(submit);
    }

    initShipDate() {
      const el = this.querySelector('[data-ships]');
      if (!el || !el.dataset.template) return;
      const date = new Date();
      let days = Number(this.dataset.shipDays || 1);
      while (days > 0) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) days -= 1;
      }
      while (date.getDay() === 0 || date.getDay() === 6) date.setDate(date.getDate() + 1);
      const label = date.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
      el.textContent = el.dataset.template.replace('[date]', label);
    }

    initCountdown() {
      const el = this.querySelector('[data-countdown]');
      if (!el) return;
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const now = new Date();
        const end = new Date(now);
        end.setHours(24, 0, 0, 0);
        const left = Math.max(0, Math.floor((end - now) / 1000));
        el.textContent = pad(Math.floor(left / 3600)) + ':' + pad(Math.floor((left % 3600) / 60)) + ':' + pad(left % 60);
      };
      tick();
      setInterval(tick, 1000);
    }
  }

  if (!customElements.get('mp-buy-box')) customElements.define('mp-buy-box', MpBuyBox);

  } catch(e) { console.error(e); }
})();
})();
